import {findPrimaryScenarioByRouteName} from './catalog'
import {prepareRouteGuideAnchors, disposeRouteGuideAnchors} from './anchors'
import {markGuideSeenInSession, saveGuideStatus, shouldAutoShowGuide} from './progress'
import {destroyActiveGuide, startGuide} from './runner'

const {canReplayGuide} = require('./runtimeCore.cjs')

let autoTimer = null
const MAX_AUTO_ATTEMPTS = 4
const AUTO_RETRY_DELAY = 360

/** 等待页面和首轮异步区域稳定后尝试自动启动；路由变化时取消旧任务。 */
export function scheduleRouteGuide(route, options = {}) {
  cancelScheduledGuide()
  destroyActiveGuide()
  disposeRouteGuideAnchors()
  const guide = findPrimaryScenarioByRouteName(route?.name)
  if (!guide || route?.meta?.comingSoon || !shouldAutoShowGuide(guide)) return
  const routeFullPath = route.fullPath
  const attemptStart = (attempt) => {
    if (options.getCurrentFullPath && options.getCurrentFullPath() !== routeFullPath) return
    prepareRouteGuideAnchors(route?.name)
    const started = startGuide(guide, {onStatus: (status) => saveGuideStatus(guide, status)})
    if (started) {
      // 只有真实弹层启动后才登记，避免慢接口页面“没看到却被当前会话跳过”。
      markGuideSeenInSession(guide)
      return
    }
    if (attempt >= MAX_AUTO_ATTEMPTS) return
    autoTimer = window.setTimeout(() => {
      autoTimer = null
      attemptStart(attempt + 1)
    }, AUTO_RETRY_DELAY)
  }
  autoTimer = window.setTimeout(() => {
    autoTimer = null
    attemptStart(1)
  }, options.delay || 620)
}

export function replayGuide(guide) {
  if (!canReplayGuide(guide)) return false
  prepareRouteGuideAnchors(guide.routeName)
  const started = startGuide(guide, {onStatus: (status) => saveGuideStatus(guide, status)})
  if (started) markGuideSeenInSession(guide)
  return started
}

export function cancelScheduledGuide() {
  if (autoTimer) window.clearTimeout(autoTimer)
  autoTimer = null
}

export function disposeGuideController() {
  cancelScheduledGuide()
  destroyActiveGuide()
  disposeRouteGuideAnchors()
}
